// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"1c771433","213":"d2bc65e8","363":"e79bb23c","425":"159ade2a","453":"b7b95b84","455":"8b8c1e2d","958":"d8ca0451","963":"23c66147"}[chunkId] + ".chunk.js";
};